
globalThis.ValueSwitcher = (function() {
  function ValueSwitcher($html) {
    this.$html = $html;
    this.$switchables = this.$html.find('*[data-target="value-switcher.switchable"]');
    this.$triggers = this.$html.find('*[data-target="value-switcher.trigger"]');

    this.init();
  }

  ValueSwitcher.init = function($ctx) {
    ($ctx || $('body')).find('*[data-sb-controller="value-switcher"]').each(function() {
      new ValueSwitcher($(this));
    });
  }

  ValueSwitcher.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var moduleInstance = this;

      this.$triggers.each(function() {
        var $trigger = $(this);

        $trigger.on('change', function() {
          moduleInstance.$switchables.each(function() {
            var $switchable = $(this),
                oldText = $switchable.text(),
                newText = $switchable.data('switch-value');

            $switchable.text(newText).data('switch-value', oldText);
          });
        });
      });
    }
  }

  return ValueSwitcher;
})();
